import { Store } from 'vuex';

import BusinessService from '@/api/BusinessService';

const getBusinessId = (store: Store<any>) => {
  const info = store.getters['business/getBusinessInfo'];

  return info && info.business && info.business.id;
};

/**
 * The wrapper boots once per document, so when the boot route skips the
 * business store factory (e.g. /public-waiting, or a transient /auth/me
 * failure during impersonation) the store stays empty for the whole SPA
 * session. Payloads that embed business.id must not be built in that state —
 * this re-hydrates the store on demand and reports whether an id is available.
 *
 * Unlike refresh-business-information.ts this deliberately does NOT emit
 * eventBus 'setBusinessInfo': that event can trigger App.vue's claim-code
 * redirect, which must not fire mid-submit.
 */
export async function ensureBusinessInfo(store: Store<any>): Promise<boolean> {
  if (getBusinessId(store)) return true;

  try {
    const { data } = await new BusinessService().getBusinessInfo();
    data.manager = data.loggedInManager;
    await store.dispatch('business/SET_BUSINESS_INFO', data);
  } catch (e) {
    console.error(e);
    return false;
  }

  return Boolean(getBusinessId(store));
}
